<ng-template #rfqCapabilityModel let-d="dismiss" data-backdrop="static" data-keyboard="false">
  <div class="row" *ngIf="isloading">
    <div class="col-md-12">
      <div class="loader animation-start">
        <span class="circle delay-1 size-2"></span>
        <span class="circle delay-2 size-4"></span>
        <span class="circle delay-3 size-6"></span>
        <span class="circle delay-4 size-7"></span>
        <span class="circle delay-5 size-7"></span>
        <span class="circle delay-6 size-6"></span>
        <span class="circle delay-7 size-4"></span>
        <span class="circle delay-8 size-2"></span>
      </div>
    </div>
  </div>
  <div *ngIf="!isloading">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Select your RFQ access capabilities</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 text-left">
          <span>{{ subHeaderText[accountType] }}</span>
        </div>
      </div>
      <div class="row m-t-15 text-left">
        <div class="col-md-6">
          Select capabilities
        </div>
        <div class="col-md-6 Deselect-All text-right" (click)="processDeSelectAll()">
          Deselect All
        </div>

      </div>
      <div class="row">
        <div class="col-md-5 p-r-0">
          <div class="Rectangle-indi manufac_scroll p-10">
            <div
              *ngFor="let singlePart of iCustomProcessViewModelOriColl | groupBy:'parentDisciplineName';let iPart = index;">
              <ul>
                <li class="Main-Topic" *ngIf="singlePart.key !== 'Let MFG.com Pick the Best Category'"
                  (click)="processAddAllToSelection(singlePart.key)">{{singlePart.key}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-2 p-l-0 p-r-0" style="padding-top: 97px;text-align: center;">
          <i class="fa fa-exchange" aria-hidden="true"></i>
        </div>
        <div class="col-md-5 p-l-0">
          <div class="Rectangle-indi manufac_scroll p-10">
            <div *ngIf="!selectedProcessParent.length">
              <span class="f-14" style="color:#919aa3">
                Click main topics to add the whole group, subtopics to add one at a time
              </span>
            </div>
            <div *ngIf="selectedProcessParent.length">
              <div *ngFor="let singlePart of selectedProcessParent">
                <ul [class.selectedCapability]="!disabledCapabilityBtn()">
                  <li class="Main-Topic" (click)="processRemoveALLFromSelection(singlePart.key)">{{singlePart.key }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer text-center" style=" justify-content: center; ">
      <button type="button" class="btn btn-save" [disabled]="disabledCapabilityBtn()" (click)="openConfirmModel();"
        style="width: 50%; ">Save Capabilities</button>
    </div>
  </div>
</ng-template>

<ng-template #rfqCapabilityConfirmationModel let-d="dismiss" data-backdrop="static" data-keyboard="false">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Confirmation RFQ access capabilities</h4>
  </div>
  <div class="modal-body text-left">
    <div class="row">{{ confirmationText[accountType] }}</div>
  </div>
  <div class="modal-footer text-center" style=" justify-content: center; ">
    <button type="button" class="btn btn-save" (click)="setCapability(2);" style="width: 50%; ">Yes</button>
    <button type="button" class="btn btn-cancel" (click)="closeConfirmModel()" style="width: 50%; ">No</button>
  </div>
</ng-template>
